// Added by Sejune Oh on 2020-04-21
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    Popper as MaterialUIPopper,
    PopperProps as MaterialUIPopperProps
} from '@material-ui/core'

interface PopperBaseProps { }
export type PopperProps = Partial<MaterialUIPopperProps> & PopperBaseProps

export const Popper: FC<PopperProps> = ({ open = false, placement, children, ...rest }) => {
    return <MaterialUIPopper open={open} placement={placement} {...rest}>{children}</MaterialUIPopper>
}
